import Model from '../Model'

export default class ModeratorRequest extends Model {
    // Set the resource route of the model
    resource() {
        return 'admin/moderator-requests'
    }
}
